import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { MatterHistory } from '../../../models/matter-history';

import { NotyService } from '../../../services/common/noty.service';
import { MatterStoreService } from '../../../services/matters/matter-store.service';
import { MatterHistoryService } from '../../../services/matters/matter-history.service';
import { ValidationFunctionsService } from '../../../services/common/validation-functions.service';

@Component({
  selector: 'app-matter-history-form',
  templateUrl: './matter-history-form.component.html',
  styleUrls: ['./matter-history-form.component.css'],
})
export class MatterHistoryFormComponent implements OnInit {
  @Input() parent_id: number;

  @Input() matter_id: number;

  @Input() matterHistoryId: number;

  @Output() formResult: EventEmitter<string> = new EventEmitter();

  formOptions: any = {
    deliver_options: [],
    matter_history_types: [],
    notification_emails: [],
    automatic_recipients: '',
  };

  formSubmitted: boolean = false;
  formSubmitting: boolean = false;

  loading: boolean = false;

  matterHistory: MatterHistory = new MatterHistory();

  matter_history_emails: Array<string> = [];
  other_emails: string = '';

  reminder_date: string;

  tags: string = '';

  constructor(private matterHistoryService: MatterHistoryService, private matterStoreService: MatterStoreService, private notyService: NotyService, private validationFunctionsService: ValidationFunctionsService) {}

  // Component lifecycle events
  ngOnInit() {
    this.matterHistoryService.getFormOptions(this.matter_id, this.parent_id).then((response_json) => {
      if (response_json) {
        this.formOptions = response_json;
        if (!this.formOptions.matter_history_types) this.formOptions.matter_history_types = [];
        if (!this.formOptions.notification_emails) this.formOptions.notification_emails = [];
        if (!this.formOptions.automatic_recipients) this.formOptions.automatic_recipients = [];
        if (!this.formOptions.other_emails) this.formOptions.other_emails = [];
      }

      if (this.matterHistoryId) {
        this.loading = true;
        this.matterHistoryService
          .edit(this.matterHistoryId)
          .then((matterHistory) => {
            this.loading = false;
            this.matterHistory = matterHistory;
            this.reminder_date = matterHistory.reminder_date;
            this.tags = matterHistory.all_tags_list;
            for (let deliveryOption of this.formOptions.deliver_options) if (this.matterHistory.reminder_delivery_methods.indexOf(deliveryOption.value) > -1) deliveryOption.checked = true;
          })
          .catch(() => {
            this.loading = false;
            this.notyService.notify('Error loading history edit', 'warning');
          });
      }
    });
  }

  // Component methods
  cancelForm() {
    this.formResult.emit('Form Cancelled');
  }

  emailChange(checked: boolean, email: string) {
    let index = this.matter_history_emails.indexOf(email);
    if (checked && index < 0) this.matter_history_emails.push(email);
    else if (!checked && index > -1) this.matter_history_emails.splice(index, 1);
  }

  formValid(): boolean {
    return !!this.matterHistory.message && !!this.matterHistory.matter_history_type_id && !this.invalidEmails();
  }

  invalidEmails(): string {
    let emails = this.other_emails.split(',');
    let invalid_emails = [];
    for (let email of emails) {
      email = email.trim();
      if (email && !this.validationFunctionsService.isEmail(email)) invalid_emails.push(`Invalid Email: ${email}`);
    }
    return invalid_emails.join('<br />');
  }

  setDeliveryMethods() {
    this.matterHistory.reminder_delivery_methods = [];
    for (let deliveryOption of this.formOptions.deliver_options) if (deliveryOption.checked) this.matterHistory.reminder_delivery_methods.push(deliveryOption.value);
  }

  submitForm() {
    this.formSubmitted = true;
    if (this.formValid()) {
      this.formSubmitting = true;
      let scope = this;
      if (this.parent_id) this.matterHistory.ancestry = `${this.parent_id}`;
      this.matterHistory.matter_id = this.matter_id;
      this.matterHistoryService
        .saveMatterHistory(
          {
            matter_history: this.matterHistory,
            matter_history_emails: this.matter_history_emails,
            parent_id: this.parent_id,
            other_emails: this.other_emails,
            reminder_date: this.reminder_date,
            tags: this.tags,
            reminder_date_struct: this.matterHistory.reminder_date_struct,
            reminder_delivery_methods: this.matterHistory.reminder_delivery_methods,
          },
          this.matterHistoryId
        )
        .then((response_json) => {
          try {
            this.formSubmitting = false;
            if (response_json.success) {
              this.notyService.notify(response_json.text || 'History created', 'success');
              this.matterHistory = new MatterHistory();
              this.matter_history_emails = [];
              this.other_emails = '';
              this.reminder_date = '';
              this.tags = '';
              if (!this.matterHistoryId && !this.parent_id) {
                this.matterStoreService.matterShowComponent!.showNewMatterHistoryForm = false;
                this.matterStoreService.matterHistoriesComponent!.loadHistories();
              } else {
                this.formResult.emit('saved');
              }
            } else {
              this.notyService.notify(response_json.text || 'Error saving history', 'error');
            }
          } catch (err) {
            console.error(err);
          }
        })
        .catch(function (err: any) {
          scope.formSubmitting = false;
          const errorMsg = err?.error?.error || err?.error?.text || 'Error saving history';
          scope.notyService.notify(errorMsg, 'error');
        });
    }
  }
}
